import React from 'react';

/** A count as the server sent it; '—' when it is missing (never a made-up zero). */
export const num = (v: number | null | undefined) => (typeof v === 'number' && Number.isFinite(v) ? v.toLocaleString() : '—');

/** A percentage as the server sends it (null when there was nothing to divide by). */
export const pct = (v: number | null | undefined) => (typeof v === 'number' && Number.isFinite(v) ? `${Number(v.toFixed(1)).toLocaleString()}%` : '—');

/** One labelled figure in a `<dl>`: used by the campaign's progress and report cards. */
export function Metric({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <div title={hint}>
      <dt className="text-xs font-semibold text-muted">{label}</dt>
      <dd className="mt-0.5 text-lg font-bold tabular-nums text-ink">{value}</dd>
    </div>
  );
}
